<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 200 200" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <g data-follow-fill="currentColor" :fill="_fill">
        <path d="M161.8 101.3c0 2.7 2.2 4.9 4.9 4.9s4.9-2.2 4.9-4.9c0-9-1.8-17.8-5.3-26-3.4-7.9-8.2-15.1-14.3-21.2-6.1-6.1-13.3-11-21.2-14.3-8.2-3.5-17-5.3-26-5.3-2.7 0-4.9 2.2-4.9 4.9s2.2 4.9 4.9 4.9c15.2 0 29.6 5.9 40.4 16.7 10.7 10.8 16.6 25.1 16.6 40.3zm-64.9 64.9c-15.2 0-29.6-5.9-40.4-16.7-10.8-10.8-16.7-25.1-16.7-40.3 0-2.7-2.2-4.9-4.9-4.9s-4.9 2.2-4.9 4.9c0 9 1.8 17.8 5.3 26 3.4 7.9 8.2 15.1 14.3 21.2s13.3 11 21.2 14.3c8.2 3.5 17 5.3 26 5.3 2.7 0 4.9-2.2 4.9-4.9s-2.1-4.9-4.8-4.9zM77 66.1c.2.7.3 1.4.3 2v6.5c0 3.6-2.9 6.5-6.5 6.5h-6.4c-3.6 0-6.5-2.9-6.5-6.5v-6.5c0-.7.1-1.4.3-2-9.7 2.6-16.6 9.1-16.6 16.7v4.9c0 3.6 2.9 6.5 6.5 6.5h39c3.6 0 6.5-2.9 6.5-6.5v-4.9c.1-7.6-6.8-14.1-16.6-16.7z" />
        <path d="M67.6 68.2c-1.8 0-3.3 1.5-3.3 3.3v3.2c0 1.8 1.5 3.3 3.3 3.3 1.8 0 3.3-1.5 3.3-3.3v-3.2c0-.9-.3-1.7-1-2.3-.6-.7-1.4-1-2.3-1zm0-3.3c9 0 16.2-8 16.2-17.9s-7.2-17.9-16.2-17.9-16.3 8-16.3 17.9 7.4 17.9 16.3 17.9zm73.2 48.2c17.9 0 32.5 14.6 32.5 32.5s-14.6 32.5-32.5 32.5-32.5-14.6-32.5-32.5 14.5-32.5 32.5-32.5zm-8.2 15c-.8-.8-2.2-.8-3.1 0l-.7.7c-.8.8-.8 2.2 0 3.1l8.1 8.1h-7c-1.2 0-2.2 1-2.2 2.2v1c0 1.2 1 2.2 2.2 2.2h8.3v4H127c-1.2 0-2.2 1-2.2 2.2v1c0 1.2 1 2.2 2.2 2.2h11.2v7c0 1.2 1 2.1 2.2 2.1h1c1.2 0 2.1-1 2.1-2.2v-7h11c1.2 0 2.2-1 2.2-2.2v-1c0-1.2-1-2.2-2.2-2.2h-11v-4h8.2c1.2 0 2.2-1 2.2-2.2v-1c0-1.2-1-2.2-2.2-2.2h-7.4l8-8c.8-.8.8-2.2 0-3l-.7-.7c-.8-.8-2.2-.8-3 0l-8 8-8-8.1z" />
      </g>
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
